import { createSlice } from "@reduxjs/toolkit"

import { type RootState } from "../../app/apis"
import { MeUser } from "./models"

type ProfileState = {
  me: MeUser | null
  impersonateMessage?: string
}

const initialState: ProfileState = {
  me: null,
}

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setMe: (state, action) => {
      const profileDetail = action.payload
      // TODO: remove later when data available with API
      profileDetail.user["address"] = {
        lat: 23.0225,
        lng: 72.5714,
      }
      state.me = action.payload
    },
    clearMe: (state) => {
      state.me = null
    },
    setImpersonateMessage: (state, action) => {
      state.impersonateMessage = action.payload
    },
  },
})

export const profileActions = profileSlice.actions

export const selectMe = (state: RootState) => state.profile.me
export const selectImpersonateMessage = (state: RootState) =>
  state.profile.impersonateMessage
